import { render, staticRenderFns } from "./CheckoutPage.vue?vue&type=template&id=2608b249&scoped=true&"
import script from "./CheckoutPage.vue?vue&type=script&lang=js&"
export * from "./CheckoutPage.vue?vue&type=script&lang=js&"
import style0 from "./CheckoutPage.vue?vue&type=style&index=0&id=2608b249&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2608b249",
  null
  
)

export default component.exports